<template>
    <v-card class="pa-3">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <v-card-text v-if="!loading" class="px-0">
            <div class="px-0 pb-4" style="border: #5cb860 1px solid">
                <v-layout
                    class="headline mb-4 px-2 py-2 font-weight-medium"
                    style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                    layout
                    row
                    justify-space-between
                    >Current Year: {{ getCurrentYear(regID) }}</v-layout
                >

                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Billed:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ total | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ paid | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Scheduled Payments:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ scheduledPayments | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Total Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ totalPaid | currency }}
                    </div>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    class="px-4 mt-3 headline font-weight-bold"
                    style="color: #5cb860;"
                >
                    <div>
                        Total Balance:
                    </div>
                    <div>
                        {{ balance | currency }}
                    </div>
                </v-layout>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        regID: { type: String },
        loading: { type: Boolean },
        total: { type: Number },
        previousBalance: { type: Number },
        paid: { type: Number },
        totalPaid: { type: Number },
        scheduledPayments: { type: Number },
        balance: { type: Number },
        pastYearsEnrollmentInfo: Array,
        account: Object,
    },
    data: () => ({
        terms: [],
    }),
    async created() {
        await this.loadRegTerms();
    },
    methods: {
        getCurrentYear(regID) {
            if (!regID) return;

            return regID.substring(2);
        },
        getPastYearsEnrollmentInfo() {
            return this.pastYearsEnrollmentInfo.filter(
                (e) => e.regID != this.regID
            );
        },
        async loadRegTerms() {
            const terms = await this.$http.get(
                "api/lapidusDayCamp/getRegTerms"
            );

            this.terms = terms;
        },
        navigateToOtherYear(regID) {
            this.$router.push({
                name: "LapidusAccountView",
                params: { id: this.account.accountID, reg_id: regID },
            });
        },
    },
};
</script>
<style>
.year-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
    font-size: 20px;
}
#enrollments {
    border-collapse: collapse;
    width: 100%;
}

#enrollments td,
#enrollments th {
    border: 1px solid #ddd;
    padding: 8px;
}

#enrollments tr:nth-child(odd) {
    background-color: #f2f2f2;
}

#enrollments tr:hover {
    background-color: #ddd;
}

#enrollments th {
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: left;
    background-color: #4caf50;
    color: white;
}
</style>
